module.exports = __webpack_public_path__ + "static/img/404.5f76e018.png";